<div class="admin-dealer-health">
  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h4 class="m-0">
      Dealer Health<span *ngIf="dealers.length" class="text-muted fs-6"> ({{ dealers.length }})</span>
    </h4>
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <span class="text-muted small" *ngIf="response">
        Generated {{ response.generatedAt | date : 'dd/MM/yyyy HH:mm' }}
        <ng-container *ngIf="response.fromCache">(cached)</ng-container>
        · window {{ response.checkWindowDays }}d
        <ng-container *ngIf="response.clickMetricsAsOf">
          · clicks as of {{ response.clickMetricsAsOf | date : 'dd/MM/yyyy' }}
        </ng-container>
      </span>
      <button class="btn btn-sm btn-outline-secondary" (click)="toggleUnmonitored()">
        {{ showUnmonitored ? 'Hide' : 'Show' }} unmonitored
      </button>
      <button class="btn btn-outline-primary" (click)="load(true)" [disabled]="loading"
              title="Recalculate from stored data (no dealer sites are called)">
        Refresh
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4 text-muted">Loading dealer health…</div>

  <div *ngIf="!loading && errored" class="alert alert-warning">
    Unable to load dealer health. Please try again.
  </div>

  <div *ngIf="!loading && !errored && dealers.length === 0" class="text-center py-4 text-muted">
    No dealers to show.
  </div>

  <div class="table-responsive" *ngIf="!loading && !errored && dealers.length > 0">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Dealer</th>
          <th>Transport</th>
          <th>Fetch Health</th>
          <th>Price Extraction</th>
          <th class="text-nowrap">Found / Not Found / Failed</th>
          <th class="text-center">DVLA New-Issue</th>
          <th class="text-end">Sole</th>
          <th class="text-end">Shared</th>
          <th>Overall</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of dealers" [class.table-active]="d.discoveryOnly">
          <td>
            <div class="fw-semibold">{{ d.dealerName }}</div>
            <div class="text-muted small font-monospace">{{ d.siteKey }}</div>
            <span *ngIf="d.discoveryOnly" class="badge bg-info text-dark mt-1">DISCOVERY ONLY</span>
            <span *ngIf="!d.active" class="badge bg-secondary mt-1">INACTIVE</span>
          </td>
          <td><span class="badge rounded-pill bg-light text-dark border">{{ d.transport }}</span></td>
          <td>
            <span class="badge" [ngClass]="statusBadgeClass(d.website.status)"
                  [title]="d.website.lastFailureDetail || ''">
              {{ statusLabel(d.website.status) }}
            </span>
            <div class="text-muted small">
              <span *ngIf="d.website.lastSuccessfulFetch">
                fetch ok {{ d.website.lastSuccessfulFetch | date : 'dd/MM HH:mm' }}
              </span>
              <span *ngIf="!d.website.lastSuccessfulFetch">no recent fetch</span>
              <span *ngIf="d.website.lastHttpStatus" class="text-danger">
                · last fail HTTP {{ d.website.lastHttpStatus }}
              </span>
            </div>
          </td>
          <td>
            <span class="badge" [ngClass]="statusBadgeClass(d.priceCheck.status)">
              {{ statusLabel(d.priceCheck.status) }}
            </span>
            <div class="text-muted small">
              <span *ngIf="d.priceCheck.lastSuccessfulExtraction">
                found {{ d.priceCheck.lastSuccessfulExtraction | date : 'dd/MM HH:mm' }}
              </span>
              <span *ngIf="!d.priceCheck.lastSuccessfulExtraction">no extraction in window</span>
              · fail {{ failurePercent(d) }}
            </div>
          </td>
          <td class="text-nowrap">
            <span class="text-success fw-semibold">{{ d.priceCheck.foundCount }}</span> /
            <span>{{ d.priceCheck.notFoundCount }}</span> /
            <span class="text-danger fw-semibold">{{ d.priceCheck.checkFailedCount }}</span>
          </td>
          <td class="text-center">
            <span [ngClass]="d.offersDvlaNewIssue ? 'text-success' : 'text-muted'">
              {{ d.offersDvlaNewIssue ? '✔' : '✘' }}
            </span>
          </td>
          <td class="text-end">{{ d.soleListings === null ? '—' : d.soleListings }}</td>
          <td class="text-end">{{ d.sharedListings === null ? '—' : d.sharedListings }}</td>
          <td>
            <span class="badge" [ngClass]="overallBadgeClass(d.overall)">
              {{ overallLabel(d.overall) }}
            </span>
          </td>
          <td class="small text-muted" style="max-width: 260px">
            <div *ngFor="let note of d.notes">{{ note }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Coverage snapshot bar -->
  <div class="d-flex align-items-center flex-wrap gap-2 mt-2 p-2 bg-light rounded"
       *ngIf="!loading && !errored && response">
    <span class="small text-muted" *ngIf="response.coverageAvailable">
      Sole/shared snapshot as of
      {{ response.coverageAsOf | date : 'dd/MM/yyyy HH:mm' }} — {{ response.coverageSource }}
    </span>
    <span class="small text-muted" *ngIf="!response.coverageAvailable">
      Sole/shared counts unavailable — no fresh precomputed source exists.
    </span>
    <span class="small text-danger" *ngIf="coverageError">{{ coverageError }}</span>
    <div class="ms-auto">
      <button class="btn btn-sm btn-outline-primary" (click)="loadCoverage()" [disabled]="coverageLoading"
              title="Read-only aggregation over the stored compare cache. May take up to two minutes; cached for 24h.">
        <span *ngIf="coverageLoading" class="spinner-border spinner-border-sm me-1"></span>
        {{
          coverageLoading
            ? 'Computing (may take up to 2 min)…'
            : response.coverageAvailable
            ? 'Recompute coverage snapshot (up to 2 min)'
            : 'Compute coverage snapshot (up to 2 min)'
        }}
      </button>
    </div>
  </div>
</div>
